import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_HTTP_METHOD, WIZ_COMMAND_RESPONSE_TYPE} from '@wizeoo/akm-core-lib';

export class LogoutCommand extends WizCommand<string> {
  constructor() {
    super();

    this.configureRemote('sso/logout', {}, null, WIZ_COMMAND_HTTP_METHOD.GET, WIZ_COMMAND_RESPONSE_TYPE.TEXT, false);
  }

  /** neutralisation */
  public wizFault()  {
    
  }

}
